import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=46b4a6ae&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=46b4a6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4a6ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b4a6ae')) {
      api.createRecord('46b4a6ae', component.options)
    } else {
      api.reload('46b4a6ae', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=46b4a6ae&scoped=true&", function () {
      api.rerender('46b4a6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/preview.vue"
export default component.exports